/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgDocumentRefreshBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.7727 19.0138H3.55454C2.97213 19.0138 2.5 18.5485 2.5 17.9746V2.03926C2.5 1.46529 2.97213 1 3.55454 1H7.7727M7.7727 1H8.12421C12.7835 1 16.5605 4.72234 16.5605 9.31407M7.7727 1C9.51991 1 10.9363 2.39588 10.9363 4.11778V5.50345C10.9363 6.07742 11.4084 6.54271 11.9909 6.54271H13.3969C15.1441 6.54271 16.5605 7.93859 16.5605 9.66049V10.0069M21.5 16.7046H18.5751M21.5 16.7046V13.822M21.5 16.7046L19.6363 14.8669C19.056 14.2939 18.3196 13.8592 17.469 13.6346C14.8906 12.9537 12.2403 14.4617 11.5495 17.0027M10.9363 22.6491V19.7665M10.9363 19.7665H13.8613M10.9363 19.7665L12.7999 21.6043C13.3802 22.1772 14.1166 22.6119 14.9671 22.8365C17.5455 23.5174 20.1958 22.0094 20.8867 19.4684"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgDocumentRefresh = wrapIcon(SvgDocumentRefreshBase);
export default SvgDocumentRefresh;
